<template>
  <b-modal
    ref="largeImgModal"
    centered
    class="p-0 modal-row"
    hide-footer
    hide-header
    size="md"
  >
    <b-button-close @click="hideLargeImgModal()">×</b-button-close>
    <div class="d-block text-center">
      <img
        :src="getStructureImageUrl(smiles)"
        alt=""
        class="large-img"
      />
    </div>
  </b-modal>
</template>

<script>
import { eventBus, getStructureImageUrl } from '@/main'

export default {
  data() {
    return {
      smiles: null,
    }
  },

  created() {
    eventBus.$on('SHOW_LARGE_IMG', (smiles) => {
      let self = this
      self.smiles = smiles
      self.$refs.largeImgModal.show()
    })
  },

  methods: {
    getStructureImageUrl(smiles, width, height) {
      return getStructureImageUrl(smiles, width, height)
    },

    hideLargeImgModal() {
      this.$refs.largeImgModal.hide()
    },
  },
}
</script>
